import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_994_6146",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_994_6146)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.4776 21.0915L11.1776 14.7607C10.825 14.9134 10.4665 15.0311 10.1024 15.1137C9.73804 15.1964 9.35154 15.2377 8.94287 15.2377C7.3457 15.2377 5.98812 14.6787 4.87012 13.5607C3.75195 12.4426 3.19287 11.0849 3.19287 9.48773C3.19287 8.97107 3.25862 8.47715 3.39012 8.00598C3.52145 7.53481 3.70829 7.0864 3.95062 6.66073L7.54287 10.234L9.68912 8.08773L6.13537 4.51473C6.56087 4.2724 7.00629 4.08232 7.47162 3.94448C7.93695 3.80665 8.42737 3.73773 8.94287 3.73773C10.5402 3.73773 11.8979 4.29673 13.0159 5.41473C14.1339 6.5329 14.6929 7.89057 14.6929 9.48773C14.6929 9.90957 14.6531 10.3025 14.5736 10.6665C14.4941 11.0306 14.3749 11.3826 14.2159 11.7225L20.5469 18.0225C20.7212 18.199 20.8084 18.4123 20.8084 18.6625C20.8084 18.9126 20.7219 19.1242 20.5489 19.2972L18.7331 21.113C18.5601 21.2858 18.3512 21.3691 18.1064 21.3627C17.8615 21.3562 17.652 21.2658 17.4776 21.0915ZM18.1161 19.5917L19.0314 18.6762L12.3719 12.0165C12.6525 11.6703 12.8595 11.2764 12.9929 10.8347C13.1262 10.3931 13.1929 9.94407 13.1929 9.48773C13.1929 8.37873 12.7967 7.39732 12.0044 6.54348C11.212 5.68965 10.2095 5.27107 8.99662 5.28773L11.1641 7.45498C11.3448 7.63582 11.4351 7.84673 11.4351 8.08773C11.4351 8.32873 11.3448 8.53965 11.1641 8.72048L8.17562 11.709C7.99479 11.8896 7.78387 11.98 7.54287 11.98C7.30187 11.98 7.09095 11.8896 6.91012 11.709L4.74287 9.54148C4.74537 10.8248 5.17679 11.8451 6.03712 12.6022C6.89745 13.3592 7.86604 13.7377 8.94287 13.7377C9.38054 13.7377 9.8182 13.6726 10.2559 13.5425C10.6934 13.4125 11.0935 13.209 11.4564 12.932L18.1161 19.5917Z",
			fill: "currentColor"
		})
	})]
});
export default SvgManage;
